

class generateHtml {
    // <div class="promotedItemViewMiniText4">Ver Producto</div>
    _generateItem(data, rawData) {
        console.log(data, rawData);
        let platformClass1 = ''
        let platformClass2 = ''
        let platformClass3 = ''
        let platformClass4 = ''
        let platformClass5 = ''
        let platformClass6 = ''
        let platformClass7 = ''
        let platformClass8 = ''

        let platformLabelText = ''

        if (data.platform === 'mercado-libre') {
            platformClass1 = 'platformClass1MercadoLibre'
            platformClass2 = 'platformClass2MercadoLibre'
            platformClass3 = 'platformClass3MercadoLibre'
            platformClass4 = 'platformClass4MercadoLibre'
            platformClass5 = 'platformClass5MercadoLibre'
            platformClass6 = 'platformClass6MercadoLibre'
            platformClass7 = 'platformClass7MercadoLibre'
            platformClass8 = 'platformClass8MercadoLibre'

            platformLabelText = 'Mercado Libre'
        }

        if (data.platform === 'amazon') {
            platformClass1 = 'platformClass1Amazon'
            platformClass2 = 'platformClass2Amazon'
            platformClass3 = 'platformClass3Amazon'
            platformClass4 = 'platformClass4Amazon'
            platformClass5 = 'platformClass5Amazon'
            platformClass6 = 'platformClass6Amazon'
            platformClass7 = 'platformClass7Amazon'
            platformClass8 = 'platformClass8Amazon'

            platformLabelText = 'Amazon'
        }


        let buttonLabel = 'Ver producto'
        if (rawData.buttonLabel) {
            buttonLabel = rawData.buttonLabel
        }

        return `
        

<div class="promotedItemViewMiniCon1 ${platformClass1}" data-openurl="${data.url}">
  <div class="promotedItemViewMiniCon2">
    <div class="promotedItemViewMiniCon3">
        <div class="promotedItemViewMiniCon4">
            <img src="${data.image}" alt="Producto Mercado Libre">
        </div>
        <div class="promotedItemViewMiniCon5 ${platformClass2}">
            <div class="promotedItemViewMiniText1 ${platformClass3}">${platformLabelText}</div>
        </div>
    </div>
  </div>
  <div class="promotedItemViewMiniCon6">
    <div class="promotedItemViewMiniCon7 ${platformClass4}">
      <div class="promotedItemViewMiniText2 ${platformClass5}">${data.title}</div>
      <div class="promotedItemViewMiniCon8">
        <div class="promotedItemViewMiniText3 ${platformClass6}">${data.description}</div>
      </div>
    </div>
    <div class="promotedItemViewMiniCon9">
        <div
            class="promotedItemViewMiniCon10 ${platformClass7} promotedItemViewMiniText4 ${platformClass8}"
            >
            ${buttonLabel}
        </div>
    </div>
  </div>
</div>



  


  
        
        
        
        `
    }

    _generateSkeleton(id) {

        return `
<div id="${id}" class="promotedItemSkeleton">

    <div class="skeletonImage shimmer"></div>

    <div class="skeletonText shimmer"></div>
    <div class="skeletonTextSmall shimmer"></div>

    <div class="skeletonButton shimmer"></div>

</div>
`
    }

}

export default new generateHtml()